import { createSelector } from 'reselect';

const appSelector = state => state.app;

export const selectAppInitialized = createSelector(appSelector, appState => appState.appInitialized);

export const selectGitSha = createSelector(appSelector, appState => appState.gitSha);

export const selectForceRefreshOnRouteChange = createSelector(
  appSelector,
  appState => appState.forceRefreshOnRouteChange
);
